import React from "react";
import PropTypes from "prop-types";
import {
  BILLING_COUNTRY_OPTIONS,
  resolveBillingCountryCode,
} from "../utils/billingPhone";
import ViewportSelect from "./ViewportSelect";

function ProfileBillingSection({
  direccion,
  ciudad,
  codigoPostal,
  country,
  onDireccionChange,
  onCiudadChange,
  onCodigoPostalChange,
  onCountryChange,
  cityError,
  postalCodeError,
  readOnly,
}) {
  const countryCode = resolveBillingCountryCode(country);

  return (
    <section className="perf-billing-section" aria-labelledby="perf-billing-title">
      <h2 id="perf-billing-title" className="perf-section-title">
        Datos de facturación
      </h2>
      <p className="perf-billing-help">
        {readOnly
          ? "Estos datos se usan en tus compras y facturas. No se pueden modificar desde el perfil."
          : "Estos datos se usan en tus compras y facturas. Puedes actualizarlos en cualquier momento."}
      </p>

      <div className="form-group">
        <label htmlFor="perf-billing-address">Dirección</label>
        <input
          id="perf-billing-address"
          type="text"
          className="form-control"
          value={direccion}
          onChange={(e) => onDireccionChange(e.target.value)}
          disabled={readOnly}
          readOnly={readOnly}
        />
      </div>

      <div className="form-group">
        <label htmlFor="perf-billing-city">Ciudad</label>
        <input
          id="perf-billing-city"
          type="text"
          className="form-control"
          value={ciudad}
          onChange={(e) => onCiudadChange(e.target.value)}
          disabled={readOnly}
          readOnly={readOnly}
          aria-invalid={cityError ? "true" : "false"}
          aria-describedby={cityError ? "perf-billing-city-error" : undefined}
        />
        {cityError ? (
          <p id="perf-billing-city-error" className="perf-field-error" role="alert">
            {cityError}
          </p>
        ) : null}
      </div>

      <div className="form-group">
        <label htmlFor="perf-billing-postal">Código postal</label>
        <input
          id="perf-billing-postal"
          type="text"
          className="form-control"
          value={codigoPostal}
          onChange={(e) => onCodigoPostalChange(e.target.value)}
          disabled={readOnly}
          readOnly={readOnly}
          aria-invalid={postalCodeError ? "true" : "false"}
          aria-describedby={postalCodeError ? "perf-billing-postal-error" : undefined}
        />
        {postalCodeError ? (
          <p id="perf-billing-postal-error" className="perf-field-error" role="alert">
            {postalCodeError}
          </p>
        ) : null}
      </div>

      <div className="form-group">
        <label htmlFor="perf-billing-country">País</label>
        <ViewportSelect
          id="perf-billing-country"
          className="form-control"
          value={countryCode}
          onChange={(e) => onCountryChange(e.target.value)}
          disabled={readOnly}
        >
          {BILLING_COUNTRY_OPTIONS.map((option) => (
            <option key={option.code} value={option.code}>
              {option.label}
            </option>
          ))}
        </ViewportSelect>
      </div>
    </section>
  );
}

ProfileBillingSection.propTypes = {
  direccion: PropTypes.string.isRequired,
  ciudad: PropTypes.string.isRequired,
  codigoPostal: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  onDireccionChange: PropTypes.func.isRequired,
  onCiudadChange: PropTypes.func.isRequired,
  onCodigoPostalChange: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  cityError: PropTypes.string,
  postalCodeError: PropTypes.string,
  readOnly: PropTypes.bool,
};

ProfileBillingSection.defaultProps = {
  cityError: "",
  postalCodeError: "",
  readOnly: false,
};

export default ProfileBillingSection;
